import React from "react";
import {Divider, List, NavBar} from "antd-mobile";
import {useNavigate} from "react-router-dom";
import {t} from "../../../i18n";
import {GlobalOutline} from "antd-mobile-icons";
import { getNavBarContainerStyle } from "../../../utils/deviceUtils";
import {PickupSettingsPath} from "../../../enums/PickUpNavigatePathEnum";
import {ReactComponent as NavigationAppSvg} from "./icons/svgs/navigationApp.svg";

interface PickUpSettingsProps {
}


const PickUpSettingsPage: React.FC<PickUpSettingsProps> = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col h-screen bg-white">
            <div {...getNavBarContainerStyle()}>
                <NavBar
                    onBack={() => navigate(-1)}
                >
                    {t('pages.pickUp.useMenu.settings')}
                </NavBar>
            </div>
            <Divider/>
            <List
                className="flex-grow"
                style={{
                    '--border-bottom': 'none',
                    '--border-top': 'none',
                }}>
                <List.Item prefix={<GlobalOutline/>} onClick={() => {
                    navigate(PickupSettingsPath.PICKUP_SETTINGS_LANGUAGE)
                }}>
                    {t('pages.pickUp.useMenu.language')}
                </List.Item>
                <List.Item prefix={<NavigationAppSvg width={19} height={19} />} onClick={() => {
                    navigate(PickupSettingsPath.PICKUP_SETTINGS_NAVIGATION_APP)
                }}>
                    {t('pages.useMenu.navigationApp')}
                </List.Item>
            </List>

        </div>
    );
};

export default PickUpSettingsPage;